import { Injectable } from '@angular/core';
import { TabulationI } from '@interfaces/tabulation.interface';
import { CustomerSocketService } from '@events/customer/customer-socket.service';
import { ChangeOperationCollectionEventI } from '@interfaces/change-operation-collection-event.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabulationsSocketService {
  private eventName = 'tabulations-change';
  private changeSubject = new BehaviorSubject<ChangeOperationCollectionEventI<TabulationI> | null>(null);
  public change$ = this.changeSubject.asObservable();
  constructor(private socketService: CustomerSocketService) {}
  public init() {
    this.socketService.init();
    this.socketService.socket.on(this.eventName, (payload: ChangeOperationCollectionEventI<TabulationI>) => {
      this.changeSubject.next(payload);
    });
  }
}
